import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const ContextFour = () => {
    return (
        <div className="App">
            <div className="App-body">
                <p>
                    You have discovered the secret flash drive behind the loose outlet, and your first instinct is to plug 
                    the flash drive in. You are unsure of what to expect, but you know it cannot be be good. You decide to
                    return back to your cubicle before further investigating the flash drive.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='/BoxThree'>Go to Box Three</Button>
            </div>
        </div>
    );
  };

export default ContextFour;